$(function() {

	$(".breadcrumbs").find(".mezo .symbol").click(function() {

		var $mezo = $(this).closest(".mezo");

		$mezo.toggleClass("expanded");

		if ($mezo.is(".expanded")) {
			$(document.body).on("click.mobile-breadcrumbs", function() {
				$mezo.find(".symbol").triggerHandler("click");
				return false;
			});

			$mezo.find(".popup").on("click.mobile-breadcrumbs", function(e) {
				e.stopPropagation();
			});

			var leftPos;
			leftPos = $mezo.find(".symbol").position().left - 15;
			$mezo.find(".arrow").css("left", leftPos+"px");

		} else {
			$(document.body).off("click.mobile-breadcrumbs");
			$mezo.find(".popup").off("click.mobile-breadcrumbs");
		}

		return false;

	});

/*
	$("#load-next-button-b").click(function() {
		var top = $(window).scrollTop();
		$(this).addClass("working");
		var href = $(this).attr("href");
		$("#productlist").load(href + " #productlist", function() {
			//$("#load-next-button-b").remove();
			$(window).scrollTop(top + 20);
			window.history.pushState({}, null, href);
		});
		return false;
	});
	*/

});
